import React, { useEffect, useState } from 'react';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Link,
  Text,
  Stack,
  Heading,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/core';
import { SecondaryButton } from '../Buttons';
import { blocAPI } from '../../api/blocs';

const DpeHistoryModal = ({ folder }) => {
  const [dpeVersions, setDpeVersions] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const fetchDpeVersions = async () => {
    try {
      const response = await blocAPI.getBloc(folder.id, 'bloc_a_ergo_diagnostic');
      const versions = response.blocAErgoDiagnostic.folder.dpeVersions || [];
      setDpeVersions(versions);
    } catch (error) {
      console.error('Error fetching DPE versions:', error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchDpeVersions();
    }
  }, [isOpen, folder.id]);

  const typeToLabel = {
    'complete': 'Compte-rendu complet',
    'workRecommendations': 'Préconisations de travaux',
    'allRecommendations': 'Toutes les préconisations',
    'word': 'Format Word',
    'housingAutonomyDiagnostic': 'Diagnostic autonomie logement',
  };

  return (
    <>
      <Tooltip
        zIndex={1000}
        bg="semiDarkGray.900"
        aria-label="Historique des comptes-rendus"
        label="Historique des comptes-rendus"
        placement="top"
      >
        <SecondaryButton onClick={onOpen} mb={4}>
          Consulter les versions de comptes-rendus successives
        </SecondaryButton>
      </Tooltip>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent rounded="lg">
          <ModalHeader as="div" bg="darkGray" color="white">
            <Heading as="h2" fontSize="xl" fontWeight="bold">
              <Text
                as="span"
                fontFamily="heading"
                opacity="0.5"
                textTransform="uppercase"
                fontWeight="600"
              >
                Dossier n°{' '}
              </Text>
              {folder.formattedId}{' '}
              <Text as="span" d="inline-block" mx={2} opacity="0.65">
                -
              </Text>{' '}
              <Text mt={2} as="small">
                {folder.recipientFullName || '-'}
              </Text>
            </Heading>
          </ModalHeader>
          <ModalCloseButton color="white" _focus={{ shadow: 'none' }} />
          
          <ModalBody py={5}>
            <Stack spacing={4}>
              {dpeVersions.length > 0 ? (
                dpeVersions.map((version) => (
                  <Box key={version.id}>
                    <Text>{typeToLabel[version.uploadType]} ({version.createdAt})</Text>
                    <Link
                      key={version.id}
                      href={version.downloadLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="coral.900"
                      fontWeight={600}
                      _hover={{ textDecoration: 'underline' }}
                    >
                      {version.sharepointFilename}
                    </Link>
                  </Box>
                ))
              ) : (
                <Text color="gray.500">
                  Aucun compte-rendu n'a été enregistré
                </Text>
              )}
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DpeHistoryModal;